module.exports = __webpack_public_path__ + "media/video.371e1ccf.mp4";